/**
 * @file Formats an ISO date as a relative time, for example "3 days ago".
 */

import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

const LABEL_NEVER = "Never";

/**
 * Formats the given ISO date as a relative time, or a fallback when it is missing.
 */
const ago = (isoDate?: string, shouldReturnNever = false): string => {
  if (isoDate) {
    const relative = dayjs(isoDate).fromNow();

    return relative;
  }

  const fallback = shouldReturnNever
    ? LABEL_NEVER
    : "";

  return fallback;
};

export default ago;
